/**
 * DownloadQuoteModals — renders the two modals owned by ``useDownloadQuoteGate``
 * from the ``gate`` object it returns. Mount one per gate instance.
 */
import React from 'react';

import InsufficientCreditsModal from './InsufficientCreditsModal';
import PaidDownloadConfirmModal from './PaidDownloadConfirmModal';

export default function DownloadQuoteModals({ gate }) {
    if (!gate) return null;
    const { confirmState, insufficientState, handleConfirm, handleCancel, closeInsufficient } = gate;
    return (
        <>
            <PaidDownloadConfirmModal
                open={Boolean(confirmState)}
                quote={confirmState?.quote}
                items={confirmState?.items || []}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
            <InsufficientCreditsModal
                open={Boolean(insufficientState)}
                totalCents={insufficientState?.totalCents ?? 0}
                balanceCents={insufficientState?.balanceCents ?? 0}
                onClose={closeInsufficient}
            />
        </>
    );
}
